<template>
  <div>
    <client-only><div hidden data-cy="client-loaded"></div></client-only>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup>
const config = useRuntimeConfig()
const isTenant = config.tenantName != null && config.tenantName !== ''

// Scripts
const lendioPerformanceLogging = {
  innerHTML: `
    window.LendioPerformanceLogging = {
        debug: false,
        baseRouteChangeStart: {
          logged: false,
          startTime: null
        },
        baseTime: {
          startTime: new Date(),
          logged: false
        },
        calculateLoadTime: function(basetime, time) {
          time = time || new Date();
          basetime = basetime || this.baseTime.startTime;
          return time - basetime;
        }
      }
  `,
  type: 'text/javascript'
}
const pendo = {
  innerHTML: '(function(apiKey){(function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];v=[\'initialize\',\'identify\',\'updateOptions\',\'pageLoad\',\'track\'];for(w=0,x=v.length;w<x;++w)(function(m){o[m]=o[m]||function(){o._q[m===v[0]?\'unshift\':\'push\']([m].concat([].slice.call(arguments,0)));};})(v[w]);y=e.createElement(n);y.async=!0;y.src=\'https://cdn.pendo.io/agent/static/\'+apiKey+\'/pendo.js\';z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,\'script\',\'pendo\');})(\'23befd1d-7779-4b70-491b-d891b768d732\');',
  type: 'text/javascript'
}
const adobeTarget = isTenant ? null : {
  src: '/bp/at.min.js',
}
const adobeLaunch =  isTenant ? null : {
  src: '/bp/adobe-launch.min.js',
}
const dreams = config.NODE_ENV === 'development' ?
    { src: 'http://local-interface.lendio.com/dreamsInterface.min.js'} :
    { src: 'https://tools.lendio.com/dreamsInterface.min.js'}

const finicityConnectScript = {
  src: "https://connect2.finicity.com/assets/sdk/finicity-connect.min.js",
  tagPosition: 'bodyClose',
  defer: true,
}
const gtm = {
  innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-P6PJHT')`,
  type: 'text/javascript'
}
const lordicon = {
  src: "https://cdn.lordicon.com/lordicon.js",
  tagPosition: 'bodyClose',
  defer: true,
}
useHead({
  base: {
    href: '/bp/'
  },
  meta: [
    { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
    { 'http-equiv': 'content-type', content: 'text/html; charset=UTF-8' },
    { 'name': 'URL', content: 'http://www.lendio.com' },
    { 'name': 'language', content: 'ENG' },
    { 'name': 'subject', content: '' },
    { 'name': 'viewport', content: 'width=device-width, initial-scale=1' },
    { 'name': 'msapplication-config', content: '/browserconfig.xml' },
    { 'name': 'theme-color', content: '#00bff0' },
  ],
  link: [
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/images/apple-touch-icon.png'},
    { rel: 'manifest', sizes: '180x180', href: 'images/manifest.json'}
  ],
  titleTemplate: (string) => string
})

useHead({
  script: [
    lendioPerformanceLogging,
    pendo,
    gtm,
    finicityConnectScript,
    adobeTarget,
    adobeLaunch,
    dreams,
    lordicon,
  ].filter(x => !!x)
})

onMounted(() => {
  const fontAwesomeScript = {
    src: 'https://kit.fontawesome.com/bf62dec52b.js',
    crossorigin: 'anonymous',
    async: true,
    defer: true
  }
  const fontAwesomeConfig = {
    innerHTML: 'window.FontAwesomeConfig = { searchPseudoElements: true }',
    type: 'text/javascript'
  }

  let hasFontAwesome;
  document.getElementsByTagName('html')[0]?.classList?.forEach((item) => {
    if (item.includes('fontawesome')) {
      hasFontAwesome = true
    }
  })
  if (!hasFontAwesome) {
    useHead({
      script: [
        fontAwesomeScript,
        fontAwesomeConfig
      ]
    }, { mode: 'client' })
  }
})

</script>
<style lang="scss">
  @import '/assets/styles/mp-transitions.scss'
</style>
